import { useTranslation } from 'react-i18next';

import { AppRoute, BuildingScreenTab, camelCasify, hasPermission } from '../../utils/navigation';
import { BuildingDetails } from '../../types/building';
import { User } from '../../types/user';
import { GetEnergiObjektTypeFromMatrikkel } from '../../utils/matrikkelBygningsTyper';
import { useGetBuildingAddress } from '../../hooks/useGetBuildingAddress';

export const isValidBuildingTab = (tab: string) => Object.values(BuildingScreenTab).includes(tab as BuildingScreenTab);

export const hasDocumentAccess = (building: BuildingDetails, user?: User) => {
  return (
    building.kanEnergimerkesAvPrivatPerson &&
    (hasPermission(AppRoute.SOKNAD, user) || building.gyldigSoknad?.registreringForSteg1)
  );
};

export const useAddressBuildingTitle = (tab?: string, building?: BuildingDetails) => {
  const { getBuildingAddress } = useGetBuildingAddress();
  const { t } = useTranslation();

  if (!building || !tab) {
    return '';
  }

  const energiobjektType = GetEnergiObjektTypeFromMatrikkel(building.kanEnergimerkesAvPrivatPerson);

  const addressText = getBuildingAddress(building.adresse);
  const tabTitle = t(`buildingScreen.tab.${camelCasify(tab)}.tabTitle`, {
    context: energiobjektType
  });

  return [tabTitle, addressText].join(' | ');
};
